import {Branding} from '@hconnect/common/branding/Branding.types'

import {BrandingState} from './Branding.reducer'

export const selectBranding = (state: any): BrandingState => state.branding
export const selectBrandingConfig = (state: any): Branding => {
  const branding = selectBranding(state)
  return branding.config ? branding.config : {}
}
